import { render, staticRenderFns } from "./CourseComplementaryMaterial.vue?vue&type=template&id=79e9be96&scoped=true"
import script from "./CourseComplementaryMaterial.vue?vue&type=script&lang=js"
export * from "./CourseComplementaryMaterial.vue?vue&type=script&lang=js"
import style0 from "./CourseComplementaryMaterial.vue?vue&type=style&index=0&id=79e9be96&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e9be96",
  null
  
)

export default component.exports